import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit, isEmpty, scrollToComponent } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import {shareOfSearchStatusScoreFilters} from "../../@signals";


export default function useShareOfSearchStatusScoreMapData() {
    const { showToast } = useAppToast()

    const dataScore = useSignal({})
    const keywordName = useSignal("")
    const isLoadingDataScore = useSignal(false)

    useEffect(() => {
        if (!isEmpty(shareOfSearchStatusScoreFilters.value)) batch(() => {
            isLoadingDataScore.value = true
            dataScore.value = {}
            showToast.promise(postSubmit(`${WEBBACK_V2_API}/share-of-search/keyword-status/score-all`, shareOfSearchStatusScoreFilters.value).then(res => batch(() => {
                dataScore.value = res.data
                keywordName.value = res.keywordName
                isLoadingDataScore.value = false
            })).catch(() => showToast.error()
            ).finally(() => scrollToComponent('evolution-chart')))
        })

        if (isEmpty(shareOfSearchStatusScoreFilters.value)) batch( () => {
            dataScore.value = {}
            keywordName.value = ""
        })

    }, [JSON.stringify(shareOfSearchStatusScoreFilters.value)]);

    const resetScoreData = () => batch(() => {
        dataScore.value = {}
        keywordName.value = ""
        shareOfSearchStatusScoreFilters.value = {}
    })

    return {
        dataScore: dataScore.value,
        isLoadingDataScore: isLoadingDataScore.value,
        keywordName: keywordName.value,
        resetScoreData
    }
}